export const RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS =
	'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';

export const RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS =
	'SERVICEDESK_QUEUES_PRIORITY_GROUPS';

export const RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';

export const SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES =
	'SERVICEDESK_QUEUES_SIDEBAR_VIEW_ALL_QUEUES';

export const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;
